import { cliSimpleGit } from '../cli-simple-git.js';

/** Resolve a branch name to a commit SHA (supports branch names containing `/`). */
export async function resolveBranchCommit(repoAbsPath: string, branch: string): Promise<string | null> {
  const branchRef = branch.trim();
  if (!branchRef) return null;
  try {
    return (await cliSimpleGit(repoAbsPath).revparse([`${branchRef}^{commit}`])).trim();
  } catch {
    return null;
  }
}
